import { render, staticRenderFns } from "./PatientPurchaseAgainList.vue?vue&type=template&id=51ffdb6a&scoped=true&"
import script from "./PatientPurchaseAgainList.vue?vue&type=script&lang=js&"
export * from "./PatientPurchaseAgainList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ffdb6a",
  null
  
)

export default component.exports